


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'
import UiPhoneInput from '@/components/ui/ui-phone-input.vue'

@Component({
  components: {
    Card,
    UiPhoneInput,
  }
})
export default class StorybookPhoneInput extends Vue {
  phoneNumber: boolean = false
}
